export default __webpack_public_path__ + "static/media/ColorDashboard.47275c32.svg";